import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, orderBy, query, serverTimestamp, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db, storage } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';
import { useParams, useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { Document, Page, Text, View, StyleSheet, pdf } from "@react-pdf/renderer";
import numberToWords from "number-to-words";
import { onAuthStateChanged } from 'firebase/auth';
import {
    Card, CardContent, Typography, Button, Stack, Avatar, Divider, Box, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Paper, Chip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
    FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, TextField
} from "@mui/material";

import Close from "@mui/icons-material/Close";
import SwapHoriz from "@mui/icons-material/SwapHoriz";
import Edit from "@mui/icons-material/Edit";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

function Reservationdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const navigate = useNavigate();

    const [serviceModalOpen, setServiceModalOpen] = useState(false);
    const [custModalOpen, setCustModalOpen] = useState(false);
    const [roomModalOpen, setRoomModalOpen] = useState(false);
    const [payModalOpen, setPayModalOpen] = useState(false);
    const [extendModalOpen, setExtendModalOpen] = useState(false);
    const [reduceModalOpen, setReduceModalOpen] = useState(false);
    const [exchangeModalOpen, setExchangeModalOpen] = useState(false);
    const [exchangeItem, setExchangeItem] = useState(null);
    const [returnPaymentOpen, setReturnPaymentOpen] = useState(false);
    const [checkoutOpen, setCheckoutOpen] = useState(false);
    const [paymodeEditOpen, setPaymodeEditOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [propertyData, setPropertyData] = useState({});
    const [propertyId, setPropertyId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [userData, setUserData] = useState(null);
    const { documentId } = useParams();
    const [services, setservices] = useState([]);

    const [bookingrooms, setbookingrooms] = useState([]);
    const [roomtypes, setroomtypes] = useState([]);
    const [rooms, setrooms] = useState([]);
    const [plans, setplans] = useState([]);
    const [itemDetails, setitemDetails] = useState([]);
    const [username, setusername] = useState("");

    const [extendRoom, setextendRoom] = useState(0);

    const [bookingServices, setBookingServices] = useState([]);
    const [checkindetails, setcheckindetails] = useState([]);
    const [bookingData, setbookingData] = useState({});
    const [extraservices, setextraservices] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [bookedRoomIds, setBookedRoomIds] = useState([]);

    // Payments
    const [paymode1, setpaymode1] = useState("");
    const [amount1, setamount1] = useState(0);
    const [paytime1, setpaytime1] = useState(moment().format('YYYY-MM-DD HH:mm A'));
    const [paymode2, setpaymode2] = useState("");
    const [amount2, setamount2] = useState(0);
    const [paytime2, setpaytime2] = useState("");

    const [entryTiming, setentryTiming] = useState("");
    const [serviceamount, setserviceamount] = useState(0);
    const [rooamount, setrooamount] = useState(0);
    const [roundoff, setroundoff] = useState(0);
    const [totalamount, settotalamount] = useState(0);
    const [advance, setadvance] = useState(0);
    const [remaining, setremaining] = useState(0);
    const [note, setnote] = useState("");

    const [serviceid, setserviceid] = useState("");
    const [roomid, setroomid] = useState("");
    const [servamount, setservamount] = useState("");
    const [quantity, setquantity] = useState(1);
    const [discountupto, setdiscountupto] = useState(10);
    const [discount, setdiscount] = useState(0);
    const [servicerate, setservicerate] = useState(0);

    // Customer
    const [custname, setcustname] = useState("");
    const [mobile, setmobile] = useState("");
    const [email, setemail] = useState("");
    const [address, setaddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [gender, setgender] = useState("Male");
    const [visitpurpose, setvisitpurpose] = useState("Darshan");
    const [gstname, setgstname] = useState("");
    const [gstno, setgstno] = useState("");
    const [bookingsource, setbookingsource] = useState("Walking");
    const [documenttype, setdocumenttype] = useState("");
    const [idno, setidno] = useState("");
    const [adults, setadults] = useState("");
    const [childs, setchilds] = useState("");

    // Room
    const [rtypeid, setrtypeid] = useState("");
    const [planid, setplanid] = useState("");
    const [amount, setamount] = useState(0);
    const [roomrate, setroomrate] = useState(0);

    const [damageamount, setdamageamount] = useState(0);
    const [damagenote, setdamagenote] = useState("");
    const [anydamage, setanydamage] = useState("No");

    const [exchangeNote, setexchangeNote] = useState("");
    const [durtyRoom, setdurtyRoom] = useState("Yes");

    const [pdfURL, setPdfURL] = useState("");

    const [roomtotal, setroomtotal] = useState(0);
    const [servicetotal, setservicetotal] = useState(0);
    const [cgst, setcgst] = useState(0);
    const [subtotal, setsubtotal] = useState(0);
    const [amountInWords, setAmountInWords] = useState("");

    const [paymodeid, setpaymodeid] = useState("");
    const [uppaymode1, setuppaymode1] = useState("");
    const [uppaymode2, setuppaymode2] = useState("");

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                setUserData(user);
                try {
                    const authRolesSnap = await getDocs(collection(db, "authroles"));
                    authRolesSnap.forEach((d) => {
                        if (d.id === user.uid) setPropertyId(d.data().propertyId);
                    });

                    const userDocSnap = await getDoc(doc(db, "users", user.uid));
                    if (userDocSnap.exists()) {
                        setusername(userDocSnap.data().username);
                    }
                } catch (e) { console.log(e); }
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (propertyId && documentId) { fetchData1(); }
    }, [propertyId, documentId]);

    useEffect(() => {
        const fetchBookedRooms = async () => {
            if (!propertyId || !bookingData.checkindate || !bookingData.checkoutdate) return;
            try {
                let startDate = bookingData.checkindate;
                let today = moment().format('YYYY-MM-DD');
                if (moment(today).isAfter(startDate)) {
                    startDate = today;
                }
                let endDate = bookingData.checkoutdate;

                const q = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Booked"));
                const snap = await getDocs(q);

                let bookedIds = [];
                snap.docs.forEach(d => {
                    const r = d.data();
                    const rIn = new Date(r.checkindate);
                    const rOut = new Date(r.checkoutdate);
                    const sIn = new Date(startDate);
                    const sOut = new Date(endDate);

                    if (rIn < sOut && rOut > sIn) {
                        r.rooms?.forEach(room => {
                            bookedIds.push(room.roomid);
                        });
                    }
                });
                setBookedRoomIds([...new Set(bookedIds)]);
            } catch (e) {
                console.error("Error fetching booked rooms:", e);
            }
        };

        if (roomModalOpen || exchangeModalOpen) {
            fetchBookedRooms();
        }
    }, [roomModalOpen, exchangeModalOpen, bookingData, propertyId]);


    const fetchData1 = async () => {
        try {
            if (!documentId || !propertyId) return;
            const bookingRef = doc(db, "reservations", documentId);

            const [
                bookingSnap, extraservicesSnap, roomsSnap, paymentModesSnap,
                checkinSnap, payHistorySnap, bookingServicesSnap, propertySnap
            ] = await Promise.all([
                getDoc(bookingRef),
                getDocs(query(collection(db, "extraservices"), where("propertyId", "==", propertyId), where("status", "==", "active"))),
                getDocs(query(collection(db, "rooms"), where("propertyId", "==", propertyId))),
                getDocs(query(collection(db, "paymentmodes"), orderBy('createdAt', 'asc'), where("propertyId", "==", propertyId))),
                getDocs(query(collection(db, "checkindetails"), orderBy('createdAt', 'asc'), where("bookingid", "==", documentId))),
                getDocs(query(collection(db, "payhistory"), where("bookingid", "==", documentId))),
                getDocs(query(collection(db, "bookingservices"), where("bookingid", "==", documentId))),
                getDoc(doc(db, "properties", propertyId))
            ]);

            if (!bookingSnap.exists()) throw new Error("Booking not found!");

            const bookingData = bookingSnap.data();
            setbookingData(bookingData);

            if (bookingData.createdAt) {
                setentryTiming(moment(bookingData.createdAt.toDate()).format("DD/MM/YYYY hh:mm:ss A"));
            }

            setextraservices(extraservicesSnap.docs.map(d => ({ id: d.id, ...d.data() })));
            setroomtypes(roomsSnap.docs.map(d => ({ id: d.id, ...d.data() })));

            const paymentModes = paymentModesSnap.docs.map(d => ({ id: d.id, ...d.data() }));
            setpaymodes(paymentModes);
            setpaymode1(paymentModes[0]?.id || "");
            setpaymode2(paymentModes[0]?.id || "");

            setcheckindetails(checkinSnap.docs.map(d => ({ id: d.id, ...d.data() })));

            const bServices = bookingServicesSnap.docs.flatMap(doc => doc.data().oldservices || []);
            setBookingServices(bServices);

            if (propertySnap && propertySnap.exists()) {
                setPropertyData(propertySnap.data());
            }

            const payHistoryRaw = payHistorySnap.docs.map(d => ({ id: d.id, ...d.data() }));
            const paymodeIds = [...new Set(payHistoryRaw.flatMap(p => [p.paymode1, p.paymode2]).filter(Boolean))];
            const paymodeDocs = await Promise.all(paymodeIds.map(id => getDoc(doc(db, "paymentmodes", id))));
            const paymodeMap = {};
            paymodeDocs.forEach((snap, i) => {
                if (snap.exists()) paymodeMap[paymodeIds[i]] = snap.data().paymode;
            });

            const formattedPayHistory = payHistoryRaw.map(p => ({
                ...p,
                paymode1: paymodeMap[p.paymode1] || "",
                paymode2: paymodeMap[p.paymode2] || "",
                createdat: p.createdAt ? moment(p.createdAt.toDate()).format("DD-MM-YYYY HH:mm:ss") : ""
            }));

            formattedPayHistory.sort((a, b) => moment(b.createdat, "DD-MM-YYYY HH:mm:ss").diff(moment(a.createdat, "DD-MM-YYYY HH:mm:ss")));
            setpayhistory(formattedPayHistory);

            const roomRate = Number(bookingData.rooamount || 0);
            const days = Number(bookingData.noofdays || 0);
            const sTotal = Number(bookingData.serviceamount || 0);
            const rTotal = roomRate * days;
            const sTotalCalc = rTotal + sTotal;
            const rTax = sTotalCalc * 0.05;
            const cGst = rTax / 2;
            const sGst = rTax / 2;
            const finalGrandTotal = sTotalCalc + rTax;
            setroomtotal(rTotal.toFixed(2));
            setservicetotal(sTotal.toFixed(2));
            setsubtotal(sTotalCalc.toFixed(2));
            setcgst(cGst.toFixed(2));
            setAmountInWords(numberToWords.toWords(finalGrandTotal));

        } catch (error) {
            console.error("Fetch Error:", error);
            Toast.fire({ icon: "error", title: error.message || "Failed to load booking data" });
        }
    };

    // --- REUSABLE OTA INVENTORY SYNC HELPER ---
    const syncOTAInventory = async (roomsList, startDateStr, daysCount, operation) => {
        try {
            if (!roomsList || roomsList.length === 0 || !daysCount || daysCount < 1) return;

            const today = moment().startOf('day');
            let syncStart = moment(startDateStr).startOf('day');

            if (syncStart.isBefore(today)) {
                const diff = today.diff(syncStart, 'days');
                daysCount -= diff;
                syncStart = today;
            }

            if (daysCount < 1) return;

            const countsByType = {};
            roomsList.forEach(room => {
                if (room.rtypeid) countsByType[room.rtypeid] = (countsByType[room.rtypeid] || 0) + 1;
            });

            const otaSnap = await getDocs(query(collection(db, "ota_inventory_updates"), where("propertyId", "==", propertyId), where("status", "==", "Synced")));
            const otaUpdates = otaSnap.docs.map(d => d.data()).sort((a, b) => new Date(b.syncedAt || 0) - new Date(a.syncedAt || 0));

            const getOtaAvailability = (cmId, dateStr) => {
                const overlapping = otaUpdates.find(u => String(u.roomId) === String(cmId) && dateStr >= u.startDate && dateStr <= u.endDate);
                return overlapping ? { found: true, count: Number(overlapping.availability) } : { found: false, count: 0 };
            };

            const inventorySyncPayload = [];

            for (let day = 0; day < daysCount; day++) {
                const dateStr = syncStart.clone().add(day, "days").format("YYYY-MM-DD");

                for (const [rtypeid, count] of Object.entries(countsByType)) {
                    const matchedRoomType = roomtypes.find(rt => rt.id === rtypeid);
                    const cmId = matchedRoomType?.cmId;

                    if (cmId) {
                        const availData = getOtaAvailability(cmId, dateStr);
                        if (availData.found) {
                            let newAvail = availData.count;
                            if (operation === "consume") {
                                newAvail = Math.max(0, availData.count - count);
                            } else if (operation === "restore") {
                                newAvail = availData.count + count;
                            }

                            inventorySyncPayload.push({
                                roomId: String(cmId),
                                roomName: matchedRoomType?.roomTypeName || "Unknown",
                                startDate: dateStr,
                                endDate: dateStr,
                                availability: String(newAvail)
                            });
                        }
                    }
                }
            }

            if (inventorySyncPayload.length > 0) {
                const configSnap = await getDoc(doc(db, "channel_manager", propertyId));
                if (configSnap.exists()) {
                    const { hotelCode, authCode } = configSnap.data();
                    const payload = {
                        Authentication: { HotelCode: hotelCode, AuthCode: authCode },
                        Inventories: {
                            Inventory: inventorySyncPayload.map(item => ({
                                RoomId: item.roomId,
                                FromDate: item.startDate,
                                ToDate: item.endDate,
                                AvailableRoomCount: item.availability
                            }))
                        }
                    };

                    const response = await fetch('https://navajowhite-wren-495848.hostingersite.com/api/inventory-update', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });

                    const result = await response.json();
                    if (result.APIResponse?.IsSuccess) {
                        const promises = inventorySyncPayload.map(item => addDoc(collection(db, "ota_inventory_updates"), {
                            propertyId,
                            roomId: item.roomId,
                            roomName: item.roomName,
                            availability: item.availability,
                            startDate: item.startDate,
                            endDate: item.endDate,
                            status: "Synced",
                            syncedAt: new Date().toISOString(),
                            createdAt: serverTimestamp()
                        }));
                        await Promise.all(promises);
                    }
                }
            }
        } catch (error) {
            console.error(`OTA Sync Error (${operation}): `, error);
        }
    };
    // ------------------------------------------------

    // Payment Validation Helper
    const validatePayments = (adv, pMode1, amt1, pMode2, amt2) => {
        const numAdv = Number(adv || 0);
        if (numAdv > 0) {
            if ((Number(amt1) > 0 && !pMode1) || (Number(amt2) > 0 && !pMode2)) {
                Toast.fire({ icon: "error", title: 'Please select a payment mode for the entered amount.' });
                return false;
            }
            if (Number(amt1) === 0 && Number(amt2) === 0) {
                Toast.fire({ icon: "error", title: 'Please enter a payment amount.' });
                return false;
            }
            if (Number(amt1) < 0 || Number(amt2) < 0) {
                Toast.fire({ icon: "error", title: 'Payment amounts cannot be negative.' });
                return false;
            }
        }
        return true;
    }


    const handleamount1 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = value + Number(amount2 || 0);
        if (adv > Number(serviceamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + serviceamount });
            setadvance(0); setamount1(0);
            setremaining(Number(serviceamount) - Number(amount2));
            return;
        }
        setamount1(value); setadvance(adv.toFixed(2));
        setremaining((Number(serviceamount) - adv).toFixed(0));
    };

    const handleamount2 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = Number(amount1 || 0) + value;
        if (adv > Number(serviceamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + serviceamount });
            setadvance(0); setamount2(0);
            setremaining(Number(serviceamount) - Number(amount1));
            return;
        }
        setamount2(value); setadvance(adv.toFixed(2));
        setremaining((Number(serviceamount) - adv).toFixed(0));
    };

    const handleamountx1 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = value + Number(amount2 || 0);
        setamount1(value); setadvance(adv.toFixed(2));
        setremaining((Number(totalamount || 0) - adv).toFixed(0));
    };

    const handleamountx2 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = Number(amount1 || 0) + value;
        setamount2(value); setadvance(adv.toFixed(2));
        setremaining((Number(totalamount || 0) - adv).toFixed(0));
    };

    const handleamount3 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = value + Number(amount2 || 0);
        if (adv > Number(rooamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + rooamount });
            setadvance(0); setamount1(0);
            setremaining((Number(rooamount) - Number(amount2)).toFixed(0));
            return;
        }
        setamount1(value); setadvance(adv.toFixed(2));
        setremaining((Number(rooamount) - adv + Number(bookingData.remaining || 0)).toFixed(0));
    };

    const handleamount4 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = Number(amount1 || 0) + value;
        if (adv > Number(rooamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + rooamount });
            setadvance(0); setamount2(0);
            setremaining((Number(rooamount) - Number(amount1)).toFixed(0));
            return;
        }
        setamount2(value); setadvance(adv.toFixed(2));
        setremaining((Number(rooamount) - adv + Number(bookingData.remaining || 0)).toFixed(0));
    };

    const handleamount5 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = value + Number(amount2 || 0);
        if (adv > Number(totalamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + totalamount });
            setadvance(0); setamount1(0);
            setremaining((Number(totalamount) - Number(amount2)).toFixed(0));
            return;
        }
        setamount1(value); setadvance(adv.toFixed(2));
        setremaining((Number(totalamount) - adv).toFixed(0));
    };

    const handleamount6 = (e) => {
        let value = Number(e.target.value || 0);
        let adv = Number(amount1 || 0) + value;
        if (adv > Number(totalamount || 0)) {
            Toast.fire({ icon: "error", title: 'Advance amount should not be greater than ' + totalamount });
            setadvance(0); setamount2(0);
            setremaining((Number(totalamount) - Number(amount1)).toFixed(0));
            return;
        }
        setamount2(value); setadvance(adv.toFixed(2));
        setremaining((Number(totalamount) - adv).toFixed(0));
    };

    const removeItem = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove?`)) {
            const updatedItems = services.filter((item) => item !== itemToRemove);
            setservices(updatedItems);
            let tamount = updatedItems.reduce((acc, curr) => acc + Number(curr.servicerate), 0);
            let rxamount = Number(bookingData.noofdays || 1) * tamount;
            setserviceamount(rxamount.toFixed(2));
            setremaining((rxamount - Number(advance || 0)).toFixed(0));
        }
    };

    const removeItem1 = (itemToRemove) => {
        if (window.confirm(`Are you sure you want to remove?`)) {
            const updatedItems = bookingrooms.filter((item) => item !== itemToRemove);
            setbookingrooms(updatedItems);
            let tamount = updatedItems.reduce((acc, curr) => acc + Number(curr.roomrate), 0);
            let rxamount = Number(bookingData.noofdays || 1) * tamount;
            setrooamount(rxamount.toFixed(2));
            setremaining((rxamount - Number(advance || 0)).toFixed(0));
        }
    };

    const caltotal = (qty, dis, amnt) => {
        let rtot = Number(qty || 1) * Number(amnt || 0);
        let disc = rtot * Number(dis || 0) / 100;
        let dirate = rtot - disc;
        setservicerate(dirate.toFixed(2));
    };

    const handleServiceid = async (e) => {
        setserviceid(e.target.value);
        const docRef1 = doc(db, "extraservices", e.target.value);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) {
            setservamount(docSnap1.data().amount);
            caltotal(quantity, discount, docSnap1.data().amount);
        } else {
            setservamount(0);
            caltotal(quantity, discount, 0);
        }
    };

    const handleQuantity = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (Number(value) < 1 || !value) {
            caltotal(1, discount, servamount);
            setquantity(1);
        } else {
            caltotal(value, discount, servamount);
            setquantity(value);
        }
    };

    const handleDiscount = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (Number(value) < 0 || !value) { setdiscount(0); value = 0; }
        if (Number(value) > Number(discountupto)) {
            Toast.fire({ icon: "error", title: 'Discount cannot exceed ' + discountupto });
            setdiscount(discountupto);
            caltotal(quantity, discountupto, servamount);
        } else {
            setdiscount(value);
            caltotal(quantity, value, servamount);
        }
    };

    const handleServiceArray = async () => {
        if (!roomid || !serviceid || !servamount || !quantity || discount === null || !servicerate) {
            Toast.fire({ icon: "error", title: 'Required all fields' }); return;
        }

        let roomno = "", servicename = "";
        const docRef = doc(db, "roominfos", roomid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) roomno = docSnap.data().roomNo;

        const docRef1 = doc(db, "extraservices", serviceid);
        const docSnap1 = await getDoc(docRef1);
        if (docSnap1.exists()) servicename = docSnap1.data().servicename;

        const newItem = { roomid, serviceid, servamount, quantity, discount, servicerate, roomno, servicename, username };
        const newServices = [...services, newItem];
        setservices(newServices);

        setserviceid(""); setroomid(""); setservamount(0); setquantity(1); setdiscountupto(10); setdiscount(0); setservicerate(0);

        let tamount = newServices.reduce((acc, curr) => acc + Number(curr.servicerate), 0);
        setserviceamount(tamount.toFixed(2));
        setremaining((tamount - Number(advance)).toFixed(0));
    };

    const storeService = async () => {
        if (services.length === 0) {
            Toast.fire({ icon: "error", title: 'Please Select at least 1 Service' }); return;
        }

        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            let oldservices = [];
            if (docSnap.exists()) {
                let sAmt = Number(serviceamount || 0);
                let totalt = sAmt + Number(docSnap.data().totalamount || 0);
                let totals = sAmt + Number(docSnap.data().serviceamount || 0);
                let totalp = Number(advance || 0) + Number(docSnap.data().advance || 0);
                let totalr = Number(remaining || 0) + Number(docSnap.data().remaining || 0);

                oldservices = [...(docSnap.data().services || []), ...services];

                await updateDoc(docRef, {
                    serviceamount: totals, totalamount: totalt, advance: totalp, remaining: totalr, services: oldservices
                });

                await addDoc(collection(db, 'bookingservices'), {
                    bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                    uid: userData.uid, createdAt: Timestamp.now(), oldservices, type: "Booking",
                });

                if (Number(advance) > 0) {
                    await addDoc(collection(db, 'payhistory'), {
                        bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                        paymode1, amount1: Number(amount1), paytime1, paymode2, amount2: Number(amount2), paytime2,
                        note, paymenttype: "B", uid: userData.uid, username, type: 'Extra Service', status: 'Working', createdAt: Timestamp.now(),
                    });
                }

                setServiceModalOpen(false);
                emptyRooms();
                fetchData1();
                Toast.fire({ icon: "success", title: 'Extra services successfully added' });
            }
        } catch (e) {
            console.error(e); Toast.fire({ icon: "error", title: e.message });
        }
        setIsLoading(false);
    };

    const getCustData = () => {
        setcustname(bookingData.customers?.custname || "");
        setmobile(bookingData.customers?.mobile || "");
        setemail(bookingData.customers?.email || "");
        setaddress(bookingData.customers?.address || "");
        setcity(bookingData.customers?.city || "");
        setstate(bookingData.customers?.state || "");
        setgender(bookingData.customers?.gender || "Male");
        setgstname(bookingData.customers?.gstname || "");
        setgstno(bookingData.customers?.gstno || "");
        setdocumenttype(bookingData.customers?.documenttype || "");
        setidno(bookingData.customers?.idno || "");
        setvisitpurpose(bookingData.visitpurpose || "");
        setbookingsource(bookingData.bookingsource || "");
        setadults(bookingData.adults || "");
        setchilds(bookingData.childs || "");
    };

    const updateCust = async () => {
        const customerData = { custname, mobile, email, address, city, state, gender, gstname, gstno, documenttype, idno, uid: userData.uid, createdAt: Timestamp.now() };
        await updateDoc(doc(db, "reservations", documentId), { customers: customerData, bookingsource, visitpurpose, adults, childs });
        await updateDoc(doc(db, "customers", bookingData.customerId), { customers: customerData, bookingsource, visitpurpose });
        setCustModalOpen(false);
        fetchData1();
        Toast.fire({ icon: "success", title: 'Customer Details Successfully Updated' });
    };

    const handlemobile = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) setmobile(value);
    };

    const handleroomtypeChange = (value) => {
        setrtypeid(value); setamount(0); setroomrate(0); setdiscount(0); setdiscountupto(0);
        settotalamount(0); setrooamount(0); setadvance(0); setremaining(0); setroomid(""); setplanid("");
        onSnapshot(query(collection(db, 'roominfos'), where('roomTypeId', '==', value)), (snap) => {
            setrooms(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
        });
        onSnapshot(query(collection(db, 'roomrates'), where('roomId', '==', value)), (snap) => {
            setplans(snap.docs.map(doc => ({ id: doc.id, data: doc.data() })));
        });
    };

    const handleplanChange = async (planDocId) => {
        setplanid(planDocId);
        setamount(0);
        setroomrate(0);
        setdiscount(0);
        setdiscountupto(0);

        if (!planDocId || planDocId === "OTA") return;

        try {
            const snap = await getDoc(doc(db, "roomrates", planDocId));

            if (snap.exists()) {
                const data = snap.data();
                const fetchedRate = Number(data.rate || data.amount || 0);
                setamount(fetchedRate.toFixed(2));
                setroomrate(fetchedRate.toFixed(2));
                setdiscountupto(data.discount || 0);
            } else {
                console.warn("No such plan document found in Firestore!");
            }
        } catch (e) {
            console.error("Error fetching room rate:", e);
        }
    };

    const handleplanChange1 = async (value) => {
        setplanid(value); setamount(0); setroomrate(0); setrooamount(0); setremaining(0); setdiscount(0); setdiscountupto(0);
        if (value === "OTA") return;
        try {
            const userDocSnap = await getDoc(doc(db, 'roomrates', value));
            if (userDocSnap.exists()) {
                const data = userDocSnap.data();
                let newRate = Number(data.rate || data.amount || 0);
                let oldRate = Number(itemDetails?.roomrate || 0);
                let diffAmount = newRate - oldRate;

                setamount(newRate.toFixed(2));
                setroomrate(newRate.toFixed(2));
                setrooamount(diffAmount.toFixed(2));
                setremaining(diffAmount.toFixed(2));
                setdiscountupto(data.discount || 0);
            }
        } catch (error) {
            console.error('Error fetching plan document:', error);
            Toast.fire({ icon: "error", title: "Failed to fetch plan details" });
        }
    };

    const handleamountChange = (e) => {
        let val = e.target.value;
        setamount(val);
        let currentDiscount = Number(discount || 0);
        let newRate = Number(val) - (Number(val) * currentDiscount / 100);
        setroomrate(newRate.toFixed(2));

        if (itemDetails && itemDetails.roomrate) {
            let diffAmount = newRate - Number(itemDetails.roomrate);
            setrooamount(diffAmount.toFixed(2));
            setremaining(diffAmount.toFixed(2));
        }
    };

    const handleRoomRateChange = (e) => {
        let val = e.target.value;
        setroomrate(val);
        setdiscount(0);

        if (itemDetails && itemDetails.roomrate) {
            let diffAmount = Number(val) - Number(itemDetails.roomrate);
            setrooamount(diffAmount.toFixed(2));
            setremaining(diffAmount.toFixed(2));
        }
    };

    const handleRoomArray = () => {
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) { Toast.fire({ icon: "error", title: "All fields are required" }); return; }
        try {
            const matchedRoom = rooms.find(r => r.id === roomid);
            const roomno = matchedRoom?.data?.roomNo || "";
            const roomtypename = matchedRoom?.data?.roomTypeName || "";
            const roomTypeId = matchedRoom?.data?.roomTypeId || rtypeid;

            let planname = "OTA";
            if (planid !== 'OTA') {
                const matchedPlan = plans.find(p => p.id === planid);
                planname = matchedPlan?.data?.planName || "";
            }

            const newItem = { roomid, roomno, rtypeid: roomTypeId, roomtypename, planid, planname, amount: Number(amount), discount: Number(discount || 0), roomrate: Number(roomrate) };
            const updatedRooms = [...bookingrooms, newItem];
            setbookingrooms(updatedRooms);

            const totalRoomAmount = updatedRooms.reduce((sum, r) => sum + Number(r.roomrate), 0);
            setrooamount(totalRoomAmount.toFixed(2));
            setremaining((totalRoomAmount - Number(advance)).toFixed(0));
            calFinalTotal(bookingData.noofdays || 1, totalRoomAmount);

            setrtypeid(""); setroomid(""); setplanid(""); setamount(""); setdiscount(""); setdiscountupto(0); setroomrate("");
        } catch (error) { console.error(error); Toast.fire({ icon: "error", title: "Something went wrong" }); }
    };

    const calFinalTotal = (days, roomamountxx) => {
        let total = Number(days) * Number(roomamountxx);
        settotalamount(total.toFixed(0));
        let rOff = total.toFixed(2) - total.toFixed(0);
        setroundoff(rOff.toFixed(2));
    };

    const emptyRooms = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setroundoff(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0);
    };

    const emptyRooms1 = () => {
        setamount1(0); setpaytime1(" "); setamount2(0); setpaytime2(" ");
        setserviceamount(0); setrooamount(0); setadvance(0); setbookingrooms([]); setservices([]);
        setroundoff(bookingData.roundoff || 0);
        settotalamount(Number(bookingData.remaining || 0).toFixed(0));
        setremaining(Number(bookingData.remaining || 0).toFixed(0));
    };

    const emptyRooms2 = (item) => {
        setitemDetails(item); setrtypeid(""); setroomid(""); setplanid(""); setamount(0); setdiscountupto(0); setdiscount(0); setroomrate(0); setamount1(0);
        setpaytime1(" "); setamount2(0); setpaytime2(" "); setserviceamount(0); setrooamount(0); settotalamount(0); setadvance(0); setremaining(0);
        setbookingrooms([]); setservices([]); setextendRoom(0); setroundoff(0);
    };

    const caltotal2 = (value) => {
        setdiscount(value);
        if (value) {
            if (Number(value) > Number(discountupto)) {
                Toast.fire({ icon: "error", title: 'Discount should not be greater than ' + discountupto });
                setdiscount(discountupto); value = discountupto;
            }
            let roomr = Number(amount) * Number(value) / 100;
            let xamount = Number(amount) - roomr;
            setroomrate(xamount.toFixed(2));
            if (itemDetails?.roomrate) setrooamount((xamount - Number(itemDetails.roomrate)).toFixed(2));
        } else {
            setdiscount(0); setroomrate(Number(amount).toFixed(2));
            if (itemDetails?.roomrate) setrooamount((Number(amount) - Number(itemDetails.roomrate)).toFixed(2));
        }
    };

    const storeRoom = async () => {
        if (!bookingrooms || bookingrooms.length === 0) { Toast.fire({ icon: "error", title: 'Please select at least 1 room' }); return; }

        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (!docSnap.exists()) { Toast.fire({ icon: "error", title: "Reservation details not found" }); setIsLoading(false); return; }

            const reservationData = docSnap.data();
            const existingRooms = reservationData.rooms || [];
            const currentNoOfDays = Number(reservationData.noofdays || 1);

            let totals = (Number(rooamount || 0) / currentNoOfDays) + Number(reservationData.rooamount || 0);
            let totalt = Number(totalamount || 0) + Number(reservationData.totalamount || 0);
            let totalp = Number(advance || 0) + Number(reservationData.advance || 0);
            let totalr = Number(remaining || 0) + Number(reservationData.remaining || 0);

            for (let day = 0; day < currentNoOfDays; day++) {
                const currentInDate = moment(reservationData.checkindate).add(day, 'days').format('YYYY-MM-DD');
                const currentOutDate = moment(reservationData.checkindate).add(day + 1, 'days').format('YYYY-MM-DD');
                for (const newRoom of bookingrooms) {
                    await addDoc(collection(db, 'checkindetails'), {
                        bookingid: documentId, customerId: reservationData.customerId || "", checkindate: currentInDate, checkoutdate: currentOutDate,
                        propertyId: propertyId || "", roomid: newRoom.roomid || "", roomtypeid: newRoom.rtypeid || "", planid: newRoom.planid || "",
                        roomname: newRoom.roomno || "", planname: newRoom.planname || "", roomtype: newRoom.roomtypename || "", uid: userData?.uid || "",
                        username: username || "", status: 'Booked', createdAt: Timestamp.now(),
                    });
                }
            }

            const aggregatedRoomsArray = [...existingRooms, ...bookingrooms];
            await updateDoc(docRef, {
                rooms: aggregatedRoomsArray, rooamount: totals, totalamount: totalt, roundoff: Number(Number(roundoff || 0).toFixed(2)),
                advance: totalp, remaining: totalr, noofrooms: aggregatedRoomsArray.length
            });

            await addDoc(collection(db, 'bookingrooms'), {
                bookingid: documentId, customerId: reservationData.customerId || "", customers: reservationData.customers || {}, uid: userData?.uid || "",
                createdAt: Timestamp.now(), bookingrooms: bookingrooms,
            });

            if (Number(advance) > 0) {
                await addDoc(collection(db, 'payhistory'), {
                    bookingid: documentId, customerId: reservationData.customerId || "", customers: reservationData.customers || {},
                    paymode1, amount1: Number(amount1), paytime1: paytime1 || "", paymode2, amount2: Number(amount2), paytime2: paytime2 || "",
                    note: note || "", paymenttype: "B", uid: userData?.uid || "", username: username || "", type: 'New Room Payments', status: 'Working',
                    propertyId: propertyId || "", createdAt: Timestamp.now(),
                });
            }

            for (const targetRoom of aggregatedRoomsArray) {
                await updateDoc(doc(db, "roominfos", targetRoom.roomid), { status: "Booked" });
            }

            await syncOTAInventory(bookingrooms, reservationData.checkindate, currentNoOfDays, "consume");

            setRoomModalOpen(false); emptyRooms(); fetchData1();
            Toast.fire({ icon: "success", title: 'New Rooms successfully added' });
        } catch (error) { console.error(error); Toast.fire({ icon: "error", title: "Failed to add rooms", text: error.message }); }
        setIsLoading(false);
    };

    const storePayment = async () => {
        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let totalp = Number(advance || 0) + Number(docSnap.data().advance || 0);
                let totalr = Number(docSnap.data().totalamount || 0) - totalp;

                await updateDoc(docRef, { advance: totalp, remaining: totalr });

                if (Number(advance) > 0) {
                    await addDoc(collection(db, 'payhistory'), {
                        bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                        paymode1, amount1: Number(amount1), paytime1, paymode2, amount2: Number(amount2), paytime2, paymenttype: "B",
                        note, uid: userData?.uid || "", username, status: 'Working', type: 'Payments Taken from Customers', createdAt: Timestamp.now(),
                    });
                }
            }
            setPayModalOpen(false); emptyRooms(); fetchData1();
            Toast.fire({ icon: "success", title: 'Payment successfully added' });
        } catch (e) { console.error(e); }
        setIsLoading(false);
    };

    const storePayment1 = async () => {
        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let totalp = Number(docSnap.data().advance || 0) + Number(advance || 0);
                let totalr = Number(docSnap.data().totalamount || 0) - totalp;

                await updateDoc(docRef, { advance: totalp, remaining: totalr });

                if (Number(advance) > 0) {
                    await addDoc(collection(db, 'payhistory'), {
                        bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                        paymode1, amount1: Number(amount1), paytime1, paymode2, amount2: Number(amount2), paytime2, note,
                        uid: userData?.uid || "", username, status: 'Working', paymenttype: "B", type: 'Payments given to Customers', createdAt: Timestamp.now(),
                    });
                }
            }
            setReturnPaymentOpen(false); emptyRooms(); fetchData1();
            Toast.fire({ icon: "success", title: 'Payment successfully added' });
        } catch (e) { console.error(e); }
        setIsLoading(false);
    };

    const handleExtendRoom = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            setextendRoom(value);
            let tot = Number(value) * Number(bookingData.rooamount || 0);
            settotalamount(tot.toFixed(0)); setremaining(tot.toFixed(0));
            setroundoff((tot - Math.floor(tot)).toFixed(2));
        }
    };

    const handleReduceRoom = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length <= 2 || value) {
            if (Number(value) >= Number(bookingData.noofdays || 1)) {
                Toast.fire({ icon: "error", title: 'No of days should not be less than or equal to ' + bookingData.noofdays });
                value = bookingData.noofdays - 1;
            }
            setextendRoom(value);
            let tot = Number(value) * (Number(bookingData.rooamount || 0) + Number(bookingData.serviceamount || 0));
            settotalamount(tot.toFixed(0));
        }
    };

    const extendRoomStore = async () => {
        if (!extendRoom || Number(extendRoom) < 1) { Toast.fire({ icon: "error", title: 'Please Enter No of days' }); return; }

        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            let sIn = new Date(bookingData.checkoutdate);
            let sOut = new Date(moment(bookingData.checkoutdate).add(extendRoom, 'days').format('YYYY-MM-DD'));

            const qCheck = query(collection(db, "reservations"), where("propertyId", "==", propertyId), where("status", "==", "Booked"));
            const snapCheck = await getDocs(qCheck);
            let clashingRooms = [];
            snapCheck.docs.forEach(d => {
                if (d.id === documentId) return;
                const r = d.data();
                const rIn = new Date(r.checkindate);
                const rOut = new Date(r.checkoutdate);
                if (rIn < sOut && rOut > sIn) {
                    r.rooms?.forEach(room => {
                        if (bookingData.rooms.some(myRoom => myRoom.roomid === room.roomid)) {
                            clashingRooms.push(room.roomno);
                        }
                    });
                }
            });

            if (clashingRooms.length > 0) {
                Toast.fire({ icon: "error", title: `Cannot extend! Rooms ${[...new Set(clashingRooms)].join(', ')} are booked by others for these dates.` });
                setIsLoading(false);
                return;
            }


            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let totala = Number(totalamount) + Number(docSnap.data().totalamount || 0);
                let totalp = Number(advance || 0) + Number(docSnap.data().advance || 0);
                let totalr = totala - totalp;
                let roundofff = totala.toFixed(2) - totala.toFixed(0);
                let checkout = moment(bookingData.checkoutdate).add(extendRoom, 'days').format('YYYY-MM-DD');

                await updateDoc(docRef, {
                    totalamount: totala, roundoff: roundofff, advance: totalp, remaining: totalr,
                    checkoutdate: checkout, noofdays: Number(bookingData.noofdays || 1) + Number(extendRoom),
                });

                if (Number(advance) > 0) {
                    await addDoc(collection(db, 'payhistory'), {
                        bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                        paymode1, amount1: Number(amount1), paytime1, paymode2, amount2: Number(amount2), paytime2, paymenttype: "B",
                        note, uid: userData?.uid || "", status: 'Working', type: 'Room Extension Payment', username, createdAt: Timestamp.now(),
                    });
                }

                for (let i = 0; i < extendRoom; i++) {
                    for (let j = 0; j < (bookingData.rooms || []).length; j++) {
                        await addDoc(collection(db, 'checkindetails'), {
                            bookingid: documentId, customerId: bookingData.customerId,
                            checkindate: moment(bookingData.checkoutdate).add(i, 'days').format('YYYY-MM-DD'),
                            checkoutdate: moment(bookingData.checkoutdate).add(i + 1, 'days').format('YYYY-MM-DD'),
                            roomid: bookingData.rooms[j].roomid, roomtypeid: bookingData.rooms[j].rtypeid, planid: bookingData.rooms[j].planid,
                            roomname: bookingData.rooms[j].roomno, planname: bookingData.rooms[j].planname, roomtype: bookingData.rooms[j].roomtypename,
                            uid: userData?.uid || "", username, status: 'Booked', createdAt: Timestamp.now(),
                        });
                    }
                }

                await addDoc(collection(db, 'logs'), {
                    bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, rooms: bookingData.rooms,
                    uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Room Extended',
                });

                await syncOTAInventory(bookingData.rooms, bookingData.checkoutdate, extendRoom, "consume");

                setExtendModalOpen(false); emptyRooms(); fetchData1();
                Toast.fire({ icon: "success", title: 'Room Successfully Extended' });
            }
        } catch (e) { console.error(e); Toast.fire({ icon: "error", title: "Extend Failed" }); }
        setIsLoading(false);
    };

    const reduceRoomStore = async () => {
        setIsLoading(true);
        try {
            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let totala = Number(docSnap.data().totalamount || 0) - Number(totalamount || 0);
                let totalp = Number(advance || 0) + Number(docSnap.data().advance || 0);
                let totalr = totala - totalp;
                let roundofff = totala.toFixed(2) - totala.toFixed(0);
                let checkout = moment(bookingData.checkoutdate).subtract(extendRoom, 'days').format('YYYY-MM-DD');

                await updateDoc(docRef, {
                    totalamount: totala, roundoff: roundofff, advance: totalp, remaining: totalr,
                    checkoutdate: checkout, noofdays: Number(bookingData.noofdays || 1) - Number(extendRoom),
                });

                await addDoc(collection(db, 'logs'), {
                    bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, rooms: bookingData.rooms,
                    uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Room Reduced',
                });

                const freedStartDate = moment(bookingData.checkoutdate).subtract(extendRoom, 'days').format('YYYY-MM-DD');
                await syncOTAInventory(bookingData.rooms, freedStartDate, extendRoom, "restore");

                setReduceModalOpen(false); emptyRooms(); fetchData1();
                Toast.fire({ icon: "success", title: 'Room Successfully Reduced' });
            }
        } catch (e) { console.error(e); }
        setIsLoading(false);
    };

    const storeRoomExchange = async () => {
        if (!roomid || !rtypeid || !planid || !amount || !roomrate) { Toast.fire({ icon: "error", title: 'Please select another room with amount' }); return; }
        setIsLoading(true);
        try {
            let roomno = "", roomtypename = "", planname = "OTA";
            const docRefR = doc(db, "roominfos", roomid); const docSnapR = await getDoc(docRefR);
            if (docSnapR.exists()) roomno = docSnapR.data().roomNo || "";

            const docRefT = doc(db, "rooms", rtypeid); const docSnapT = await getDoc(docRefT);
            if (docSnapT.exists()) roomtypename = docSnapT.data().roomTypeName || "";

            if (planid !== 'OTA') {
                const docRefP = doc(db, "roomrates", planid); const docSnapP = await getDoc(docRefP);
                if (docSnapP.exists()) planname = docSnapP.data().planName || "";
            }

            const newItem1X = { roomid, rtypeid, planid, amount: Number(amount), discount: Number(discount || 0), roomrate: Number(roomrate), roomno, roomtypename, planname, username, status: "Exchanged", exchangeNote: exchangeNote || "" };

            let newArray = bookingData.rooms.filter(r => r.roomid !== itemDetails.roomid);
            newArray.push(newItem1X);

            let newroomamount = Number(bookingData.rooamount || 0) - Number(itemDetails.roomrate || 0);
            let tttttttttttt = (newroomamount + Number(bookingData.serviceamount || 0) + Number(roomrate)) * Number(bookingData.noofdays || 1);
            let rem = tttttttttttt - Number(bookingData.advance || 0);
            let roundofff = tttttttttttt.toFixed(2) - tttttttttttt.toFixed(0);

            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: tttttttttttt, roundoff: Number(roundofff).toFixed(2), rooamount: newroomamount + Number(roomrate), remaining: rem, rooms: newArray, approval1: "No",
            });

            await addDoc(collection(db, 'bookingrooms'), {
                bookingid: documentId, customerId: bookingData.customerId || "", customers: bookingData.customers || {}, uid: userData?.uid || "", createdAt: Timestamp.now(), bookingrooms: newArray,
            });

            await updateDoc(doc(db, "roominfos", roomid), { status: "Booked" });

            if (durtyRoom === 'Yes') {
                await updateDoc(doc(db, "roominfos", itemDetails.roomid), { status: "Cleaning" });
                await addDoc(collection(db, 'cleaningrooms'), {
                    bookingid: documentId, roomid: itemDetails.roomid, roomno: itemDetails.roomno || "", uid: userData?.uid || "", username, status: 'Cleaning', cleanedby: "", cleanedtime: "", createdAt: Timestamp.now(),
                });
            } else {
                await updateDoc(doc(db, "roominfos", itemDetails.roomid), { status: "Available" });
            }

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId, customerId: bookingData.customerId || "", customers: bookingData.customers || {}, rooms: bookingData.rooms || [], uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Room Exchanged',
            });

            const q1 = query(collection(db, 'checkindetails'), where('bookingid', '==', documentId), where('roomid', '==', itemDetails.roomid), where('checkindate', '>=', moment().format('YYYY-MM-DD')));
            const querySnapshot1 = await getDocs(q1);
            for (const doc1 of querySnapshot1.docs) {
                await updateDoc(doc(db, "checkindetails", doc1.id), {
                    roomid: newItem1X.roomid, roomtypeid: newItem1X.rtypeid, planid: newItem1X.planid, roomname: newItem1X.roomno, planname: newItem1X.planname, roomtype: newItem1X.roomtypename,
                });
            }

            const syncStartDate = moment.max(moment(bookingData.checkindate), moment()).format('YYYY-MM-DD');
            const daysLeft = moment(bookingData.checkoutdate).diff(moment(syncStartDate), 'days');
            if (daysLeft > 0) {
                await syncOTAInventory([itemDetails], syncStartDate, daysLeft, "restore");
                await syncOTAInventory([newItem1X], syncStartDate, daysLeft, "consume");
            }

            setExchangeModalOpen(false); emptyRooms(); fetchData1();
            Toast.fire({ icon: "success", title: 'Room Successfully Exchanged' });
        } catch (e) { console.error(e); Toast.fire({ icon: "error", title: 'Room Exchange Failed', text: e.message }); }
        setIsLoading(false);
    };

    const cancleExtraService = async (item) => {
        if (window.confirm(`Are you sure you want to Cancel Extra Service?`)) {
            let newArray = bookingData.services.filter(s => s.serviceid !== item.serviceid);
            let newservicerate = Number(item.servicerate) * Number(bookingData.noofdays || 1);
            let newrserviceamount = Number(bookingData.serviceamount || 0) - newservicerate;
            let newrtotamount = Number(bookingData.totalamount || 0) - newservicerate;
            let newRemaining = newrtotamount - Number(bookingData.advance || 0);
            let roundofff = newrtotamount.toFixed(2) - newrtotamount.toFixed(0);

            await updateDoc(doc(db, "reservations", documentId), {
                totalamount: newrtotamount, roundofff: roundofff.toFixed(2), serviceamount: newrserviceamount, remaining: newRemaining, services: newArray, approval3: "No"
            });

            await addDoc(collection(db, 'bookingservices'), {
                bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, uid: userData?.uid || "", createdAt: Timestamp.now(), oldservices: newArray
            });

            await addDoc(collection(db, 'logs'), {
                bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, services: item, uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Extra Service Canceled',
            });

            emptyRooms(); fetchData1();
            Toast.fire({ icon: "success", title: 'Extra Service Successfully Canceled' });
        }
    };

    const handleDamageAmount = (e) => {
        let val = Number(e.target.value || 0);
        setdamageamount(val);
        let tot = Number(bookingData.remaining || 0) + val;
        setremaining(tot.toFixed(0)); settotalamount(tot.toFixed(0));
        setroundoff((tot.toFixed(2) - tot.toFixed(0)).toFixed(2));
    };

    const handleCheckout = async () => {

        if (!validatePayments(advance, paymode1, amount1, paymode2, amount2)) return;

        setIsLoading(true);
        try {
            if (anydamage === 'Yes') {
                await addDoc(collection(db, 'damages'), {
                    bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, rooms: bookingData.rooms, damageamount, damagenote, uid: userData?.uid || "", username, propertyId, createdAt: Timestamp.now(),
                });
            }

            const docRef = doc(db, "reservations", documentId);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                let totalt = Number(bookingData.totalamount || 0) + Number(damageamount);
                let totalp = Number(advance || 0) + Number(docSnap.data().advance || 0);
                let totalr = totalt - totalp;
                let roundofff = totalt.toFixed(2) - totalt.toFixed(0);

                await updateDoc(docRef, {
                    totalamount: totalt, roundofff: roundofff.toFixed(2), advance: totalp, remaining: totalr, damageamount: Number(damageamount), status: 'Checkout', checkouttime: moment().format("HH:mm A"), extra4: moment().format("DD-MM-YYYY HH:mm A")
                });

                if (Number(advance) > 0) {
                    await addDoc(collection(db, 'payhistory'), {
                        bookingid: documentId, customerId: docSnap.data().customerId, customers: docSnap.data().customers,
                        paymode1, amount1: Number(amount1), paytime1, paymode2, amount2: Number(amount2), paytime2, note, paymenttype: "B", uid: userData?.uid || "", username, propertyId, status: 'Working', type: 'Payments Taken from Customers', createdAt: Timestamp.now(),
                    });
                }

                const qCheckin = query(collection(db, "checkindetails"), where("bookingid", "==", documentId));
                const checkinSnap = await getDocs(qCheckin);
                for (const d of checkinSnap.docs) { await updateDoc(doc(db, "checkindetails", d.id), { status: "Checkout" }); }

                for (let i = 0; i < (bookingData.rooms || []).length; i++) {
                    await updateDoc(doc(db, "roominfos", bookingData.rooms[i].roomid), { status: "Cleaning" });
                    await addDoc(collection(db, 'cleaningrooms'), {
                        bookingid: documentId, roomid: bookingData.rooms[i].roomid, roomno: bookingData.rooms[i].roomno, uid: userData?.uid || "", username, status: 'Cleaning', cleanedby: "", cleanedtime: "", propertyId, createdAt: Timestamp.now(),
                    });
                }

                await addDoc(collection(db, 'checkouthistory'), {
                    bookingid: documentId, invoiceno: docSnap.data().invoiceno, customerId: docSnap.data().customerId, customers: docSnap.data().customers, checkindate: bookingData.checkindate, checkoutdate: bookingData.checkoutdate, rooms: docSnap.data().rooms, uid: userData?.uid || "", username, totalamount: totalt, advance: totalp, remaining: totalr, checkoutime: moment().format('DD/MM/YYYY HH:mm:ss A'), createdAt: Timestamp.now(), propertyId
                });

                await addDoc(collection(db, 'logs'), {
                    bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Room Checkouts', propertyId
                });
            }

            const today = moment().format('YYYY-MM-DD');
            const checkoutDate = moment(bookingData.checkoutdate);
            const daysToRestore = checkoutDate.diff(moment(today), 'days');

            if (daysToRestore > 0) {
                await syncOTAInventory(bookingData.rooms, today, daysToRestore, "restore");
            }

            setCheckoutOpen(false);
            Toast.fire({ icon: "success", title: 'Room Successfully Checkout' });
            uploadInvoiceToFirebase();
            setTimeout(() => { navigate("/view-reservations"); }, 1500);
        } catch (e) { console.error(e); }
        setIsLoading(false);
    };

    const deletCheckin = async (docid) => {
        await deleteDoc(doc(db, 'checkindetails', docid));
        Toast.fire({ icon: "success", title: 'Deleted Successfully!!' });
        fetchData1();
        await addDoc(collection(db, 'logs'), {
            bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, rooms: bookingData.rooms, uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Checkin Delete',
        });
    };

    const deletPyament = async (docid) => {
        await deleteDoc(doc(db, 'payhistory', docid));
        Toast.fire({ icon: "success", title: 'Deleted Successfully!!' });
        fetchData1();
        await addDoc(collection(db, 'logs'), {
            bookingid: documentId, customerId: bookingData.customerId, customers: bookingData.customers, rooms: bookingData.rooms, uid: userData?.uid || "", username, createdAt: Timestamp.now(), type: 'Payment History Deleted',
        });
    };

    const hanldeServeAmount = (e) => {
        setservamount(e.target.value); caltotal(quantity, discount, e.target.value);
    };

    const uploadInvoiceToFirebase = async () => {
        try {
            const pdfBlob = await pdf(<InvoicePDF invoiceData={documentId} />).toBlob();
            const storageRef = ref(storage, `invoices/invoice_${Date.now()}.pdf`);
            const uploadTask = uploadBytesResumable(storageRef, pdfBlob);

            uploadTask.on("state_changed",
                (snapshot) => { },
                (error) => console.error("Upload failed:", error),
                async () => {
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                    setPdfURL(downloadURL);

                    const customerName = bookingData?.customers?.custname || "Guest";
                    const propName = "Annapurna  Executive";
                    const roomStr = bookingData?.rooms?.map(r => r.roomno).join(", ") || "N/A";
                    const totAmount = bookingData?.totalamount || 0;
                    const inDate = moment(bookingData?.checkindate).format("DD/MM/YYYY");
                    const outDate = moment().format("DD/MM/YYYY");
                    const mob = bookingData?.customers?.mobile;
                    sendWhatsAppMessage(customerName, propName, roomStr, totAmount, inDate, outDate, mob, downloadURL);

                }
            );
        } catch (error) {
            console.error("Error generating/uploading PDF:", error);
        }
    };

    const sendWhatsAppMessage = async (customerName, propName, roomStr, totAmount, inDate, outDate, mob, downloadURL) => {
        const wabaid = "1264091500117064";
        const accesstoken = "EAAcHt0w4sPkBSKT54p1Lpz2Jly0a5vhY1ks0UYJvVXygq23kb1TdHWR6bUzOfADscZBmm9eQk6CDYis6MyY3cLlYJZBvFcrgEjq0P4aHBjT9ZAMrCK3hufE5oOFKtgHFfq3BnLcR5FCqugCJ4L6WcSpyAwoKQpz0KrLGdF3iOJt9DHOZATbI2lHnym5n8umjGQZDZD";

        const payload = {
            messaging_product: 'whatsapp',
            recipient_type: 'individual',
            to: '91' + mob,
            type: 'template',
            template: {
                name: 'checkout_confirmation',
                language: { code: 'en' },
                components: [
                    {
                        type: 'header',
                        parameters: [
                            {
                                type: "document",
                                document: {
                                    link: downloadURL,
                                    filename: 'Invoice.pdf'
                                }
                            }
                        ]
                    },
                    {
                        type: 'body',
                        parameters: [
                            { type: 'text', text: customerName },
                            { type: 'text', text: propName },
                            { type: 'text', text: roomStr },
                            { type: 'text', text: String(totAmount) },
                            { type: 'text', text: inDate },
                            { type: 'text', text: outDate },
                        ],
                    }
                ],
            },
        };

        try {
            const response = await fetch(`https://graph.facebook.com/v20.0/${wabaid}/messages`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accesstoken}` },
                body: JSON.stringify(payload),
            });
            const data = await response.json();

            if (response.ok) {
                await addDoc(collection(db, 'whatsapphistory'), {
                    type: 'Checkout',
                    custname: customerName,
                    mobile: mob,
                    createdAt: Timestamp.now(),
                    propertyId: propertyId || ""
                });
            } else {
                console.error('WhatsApp API Error:', data);
            }
        } catch (error) {
            console.error('Fetch Error:', error);
        }
    };

    const handlePaymodeEdit = (id, pay1, pay2) => {
        setPaymodeEditOpen(true); setEditingId(id); setuppaymode1(pay1); setuppaymode2(pay2); setpaymodeid(id);
    };

    const updatePaymode = async () => {
        await updateDoc(doc(db, "payhistory", paymodeid), { paymode1: uppaymode1, paymode2: uppaymode2 });
        setPaymodeEditOpen(false); fetchData1(); Toast.fire({ icon: "success", title: 'Payment Mode successfully updated' });
    };

    const InvoicePDF = () => (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.invoiceContainer}>

                    <View style={styles.topHeader}>
                        <View style={styles.companyInfo}>
                            <Text style={styles.propName}>{propertyData?.hotelname || "Hotel Name"}</Text>
                            {propertyData?.gstno && <Text style={styles.propDetails}>GSTIN: {propertyData.gstno}</Text>}
                            <Text style={styles.propDetails}>
                                {propertyData?.address || ""}, {propertyData?.city || ""}, {propertyData?.state || ""} - {propertyData?.pincode || ""}
                            </Text>
                            <Text style={styles.propDetails}>Phone: +91 {propertyData?.mobile || ""} | Email: {propertyData?.email || ""}</Text>
                            {propertyData?.website && <Text style={styles.propDetails}>Website: {propertyData.website}</Text>}
                        </View>
                        <View style={styles.taxInvoiceWrapper}>
                            <Text style={styles.taxInvoiceBadge}>TAX INVOICE</Text>
                        </View>
                    </View>

                    <View style={styles.infoSection}>
                        <View style={styles.infoBox}>
                            <Text style={styles.boxTitle}>Billed To:</Text>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Name:</Text><Text style={styles.infoValue}>{bookingData?.customers?.custname || "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Address:</Text><Text style={styles.infoValue}>{bookingData?.customers?.address}, {bookingData?.customers?.city}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Phone:</Text><Text style={styles.infoValue}>{bookingData?.customers?.mobile || "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Email:</Text><Text style={styles.infoValue}>{bookingData?.customers?.email || "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>GST No:</Text><Text style={styles.infoValue}>{bookingData?.customers?.gstno || "-"}</Text></View>
                        </View>

                        <View style={styles.infoBox}>
                            <Text style={styles.boxTitle}>Invoice Details:</Text>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Invoice No:</Text><Text style={styles.infoValue}>{bookingData?.invoiceno || "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Date:</Text><Text style={styles.infoValue}>{moment().format('DD/MM/YYYY hh:mm A')}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Check-In:</Text><Text style={styles.infoValue}>{bookingData?.checkindate ? moment(bookingData.checkindate).format('DD/MM/YYYY') : "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Check-Out:</Text><Text style={styles.infoValue}>{bookingData?.checkoutdate ? moment(bookingData.checkoutdate).format('DD/MM/YYYY') : "-"}</Text></View>
                            <View style={styles.infoRow}><Text style={styles.infoLabel}>Total Days:</Text><Text style={styles.infoValue}>{bookingData?.noofdays || 0} Days</Text></View>
                        </View>
                    </View>

                    <View style={styles.table}>
                        <View style={styles.tableHeader}>
                            <Text style={styles.col1}>Room Type</Text>
                            <Text style={styles.col2}>Room No</Text>
                            <Text style={styles.col3}>Plan</Text>
                            <Text style={styles.col4}>Rate</Text>
                            <Text style={styles.col5}>Days</Text>
                            <Text style={styles.col6}>Amount</Text>
                            <Text style={styles.col7}>Discount</Text>
                            <Text style={styles.col8}>Total</Text>
                        </View>

                        {(bookingData?.rooms || []).map((item, index) => {
                            let diaamount = (Number(item.amount) - Number(item.roomrate)) * Number(bookingData.noofdays || 1);
                            let rAmount = Number(item.amount);
                            let rRate = Number(item.roomrate) * Number(bookingData.noofdays || 1);
                            let totall = rAmount * Number(bookingData.noofdays || 1);
                            return (
                                <View style={[styles.tableRow, index === bookingData.rooms.length - 1 ? { borderBottomWidth: 0 } : {}]} key={index}>
                                    <Text style={styles.col1}>{item.roomtypename}</Text>
                                    <Text style={styles.col2}>{item.roomno}</Text>
                                    <Text style={styles.col3}>{item.planname}</Text>
                                    <Text style={styles.col4}>{rAmount.toFixed(2)}</Text>
                                    <Text style={styles.col5}>{bookingData.noofdays}</Text>
                                    <Text style={styles.col6}>{totall.toFixed(2)}</Text>
                                    <Text style={styles.col7}>{diaamount.toFixed(2)} ({Number(item.discount || 0)}%)</Text>
                                    <Text style={styles.col8}>{rRate.toFixed(2)}</Text>
                                </View>
                            );
                        })}
                    </View>

                    <View style={styles.bottomSection}>
                        <View style={styles.bankBox}>
                        </View>

                        <View style={styles.totalsBox}>
                            <View style={styles.totalRow}><Text style={styles.totalLabel}>Subtotal</Text><Text style={styles.totalValue}> {subtotal}</Text></View>
                            <View style={styles.totalRow}><Text style={styles.totalLabel}>CGST (2.5%)</Text><Text style={styles.totalValue}> {cgst}</Text></View>

                            {bookingData?.customers?.state === 'Maharashtra' ? (
                                <><View style={styles.totalRow}><Text style={styles.totalLabel}>SGST (2.5%)</Text><Text style={styles.totalValue}> {cgst}</Text></View></>
                            ) : (
                                <><View style={styles.totalRow}><Text style={styles.totalLabel}>IGST (2.5%)</Text><Text style={styles.totalValue}> {cgst}</Text></View></>
                            )}

                            <View style={styles.totalRow}><Text style={styles.totalLabel}>Extra Service</Text><Text style={styles.totalValue}> {servicetotal}</Text></View>

                            <View style={styles.grandTotalRow}>
                                <Text style={styles.grandTotalLabel}>Grand Total</Text>
                                <Text style={styles.grandTotalValue}> {Number(bookingData?.totalamount || 0).toFixed(2)}</Text>
                            </View>
                        </View>
                    </View>

                    <View style={styles.footer}>
                        <Text style={styles.footerAmountInWords}>Amount in Words: {amountInWords} Rupees Only</Text>
                        <Text style={styles.footerThankYou}>Thank you for choosing {propertyData?.hotelname || "us"}!</Text>
                    </View>

                </View>
            </Page>
        </Document>
    );

    const ProfileItem = ({ label, value }) => (
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            <Typography variant="body2" fontWeight={600} textAlign="right">{value || "-"}</Typography>
        </Stack>
    );

    const ImageCard = ({ title, url }) => {
        if (!url) return null;
        return (
            <Card sx={{ borderRadius: 1, mb: 2 }}>
                <CardContent>
                    <Typography variant="subtitle2" fontWeight={600} mb={1}>{title}</Typography>
                    <Box component="img" src={url} alt={title} sx={{ width: "100%", borderRadius: 2, boxShadow: 2 }} />
                </CardContent>
            </Card>
        );
    };

    const InfoRow = ({ label, value }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            <Typography variant="body2" fontWeight={600}>{value || "-"}</Typography>
        </Stack>
    );

    const AmountRow = ({ label, value, color, bold }) => (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="text.secondary">{label}</Typography>
            <Typography variant="body2" fontWeight={bold ? 700 : 600} color={color || "text.primary"}> {value || "0.00"}</Typography>
        </Stack>
    );

    return (
        <div>
            {isLoading && (
                <div style={overlayStyle}>
                    <ClipLoader color="#36d7b7" size={60} />
                </div>
            )}
            <Menu />
            {bookingData.customerId && (
                <Card className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9 mt-3">
                                    <div className='row'>
                                        <div className='col-sm-6'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" fontWeight={700} mb={2}>Stay Details</Typography>
                                                    <Stack spacing={1.2}>
                                                        <InfoRow label="Entry Timing" value={entryTiming} />
                                                        <InfoRow label="Check-in" value={`${moment(bookingData.checkindate).format("DD/MM/YYYY")} ${bookingData.checkintime || ""}`} />
                                                        <InfoRow label="Check-out" value={`${moment(bookingData.checkoutdate).format("DD/MM/YYYY")} ${bookingData.checkouttime || ""}`} />
                                                        <Divider />
                                                        <InfoRow label="No. of Days" value={`${bookingData.noofdays || 0} Day(s)`} />
                                                        <InfoRow label="Adults" value={`${bookingData.adults || 0} Adult(s)`} />
                                                        <InfoRow label="Children" value={`${bookingData.childs || 0} Child(ren)`} />
                                                        <InfoRow label="Rooms" value={`${bookingData.noofrooms || 0} Room(s)`} />
                                                    </Stack>
                                                </CardContent>
                                            </Card>
                                        </div>
                                        <div className='col-sm-6'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" fontWeight={700} mb={2}>Billing Summary</Typography>
                                                    <Stack spacing={1.2}>
                                                        <AmountRow label="Room Amount" value={bookingData.rooamount} />
                                                        <AmountRow label="Extra Services" value={bookingData.serviceamount} />
                                                        <AmountRow label="Restaurant Amount" value={bookingData.restoamount} />
                                                        <AmountRow label="Round Off" value={bookingData.roundoff} />
                                                        <Divider />
                                                        <AmountRow label="Total Amount" value={bookingData.totalamount} bold />
                                                        <AmountRow label="Paid" value={bookingData.advance} color="success.main" />
                                                        <AmountRow label="Remaining" value={bookingData.remaining} color="error.main" bold />
                                                    </Stack>
                                                </CardContent>
                                            </Card>
                                        </div>

                                        <div className='container-fluid'>
                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">Room Details</Typography>
                                                        {bookingData.status === "Booked" && (
                                                            <Stack direction="row" spacing={1}>
                                                                <Button size="small" variant="contained" onClick={() => { emptyRooms(); setRoomModalOpen(true); }}>Add Rooms</Button>
                                                                <Button size="small" variant="outlined" color="secondary" onClick={() => { emptyRooms(); setExtendModalOpen(true); }}>Extend Rooms</Button>
                                                                <Button size="small" variant="outlined" color="error" onClick={() => { emptyRooms(); setReduceModalOpen(true); }}>Reduce Rooms</Button>
                                                            </Stack>
                                                        )}
                                                    </Stack>
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Room Type</TableCell><TableCell>Room No</TableCell><TableCell>Plan</TableCell>
                                                                    <TableCell>Amount</TableCell><TableCell>Discount</TableCell><TableCell>Room Rate</TableCell>
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {bookingData.rooms && bookingData.rooms.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.roomtypename}</TableCell>
                                                                        <TableCell>
                                                                            {item.roomno}
                                                                            {item.status === "Exchanged" && <Chip label="Exchanged" size="small" color="warning" sx={{ ml: 1 }} />}
                                                                        </TableCell>
                                                                        <TableCell>{item.planname}</TableCell>
                                                                        <TableCell> {item.amount}</TableCell>
                                                                        <TableCell>{item.discount} %</TableCell>
                                                                        <TableCell> {item.roomrate}</TableCell>
                                                                        <TableCell align="center">
                                                                            <IconButton color="primary" onClick={() => { emptyRooms2(item); setExchangeItem(item); setExchangeModalOpen(true); }}><SwapHoriz /></IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                {(!bookingData.rooms || !bookingData.rooms.length) && (
                                                                    <TableRow><TableCell colSpan={7} align="center">No rooms added</TableCell></TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CardContent>
                                            </Card>

                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Typography variant="h6" fontWeight={700} textTransform="uppercase" mb={2}>Check-In Details (Date-wise)</Typography>
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Check-In</TableCell><TableCell>Check-Out</TableCell><TableCell>Room Type</TableCell>
                                                                    <TableCell>Room No</TableCell><TableCell>Plan</TableCell>
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {checkindetails.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{moment(item.checkindate).format("DD/MM/YYYY")}</TableCell>
                                                                        <TableCell>{moment(item.checkoutdate).format("DD/MM/YYYY")}</TableCell>
                                                                        <TableCell>{item.roomtype}</TableCell>
                                                                        <TableCell>{item.roomname || item.roomno || "-"}</TableCell>
                                                                        <TableCell>{item.planname || "-"}</TableCell>
                                                                        <TableCell align="center">
                                                                            <IconButton color="error" onClick={() => deletCheckin(item.id)}><Close /></IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                {!checkindetails.length && (
                                                                    <TableRow><TableCell colSpan={6} align="center">No check-in details found</TableCell></TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CardContent>
                                            </Card>

                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">Extra Services</Typography>
                                                        {bookingData.status === "Booked" && (
                                                            <Button size="small" variant="contained" color="success" onClick={() => setServiceModalOpen(true)}>Add Extra Service</Button>
                                                        )}
                                                    </Stack>
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Service Name</TableCell><TableCell>Room No</TableCell><TableCell>Amount</TableCell>
                                                                    <TableCell>Qty</TableCell><TableCell>Discount</TableCell><TableCell>Total Rate</TableCell>
                                                                    <TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {bookingServices.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.servicename}</TableCell><TableCell>{item.roomno}</TableCell><TableCell> {item.servamount}</TableCell>
                                                                        <TableCell>{item.quantity}</TableCell><TableCell>{item.discount} %</TableCell><TableCell> {item.servicerate}</TableCell>
                                                                        <TableCell align="center">
                                                                            <IconButton color="error" onClick={() => cancleExtraService(item)}><Close /></IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CardContent>
                                            </Card>

                                            <Card sx={{ borderRadius: 1, mb: 2 }}>
                                                <CardContent>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                                                        <Typography variant="h6" fontWeight={700} textTransform="uppercase">Payment History</Typography>
                                                        <Stack direction="row" spacing={1}>
                                                            {bookingData.remaining > 0 && (
                                                                <Button size="small" variant="contained" color="warning" onClick={() => { emptyRooms1(); setPayModalOpen(true); }}>Add Payment</Button>
                                                            )}
                                                            {bookingData.remaining < 0 && (
                                                                <Button size="small" variant="contained" color="error" onClick={() => { emptyRooms1(); setReturnPaymentOpen(true); }}>Return Payment</Button>
                                                            )}
                                                        </Stack>
                                                    </Stack>
                                                    <TableContainer component={Paper} elevation={0}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Paymode 1</TableCell><TableCell>Amount 1</TableCell><TableCell>Note 1</TableCell>
                                                                    <TableCell>Paymode 2</TableCell><TableCell>Amount 2</TableCell><TableCell>Note 2</TableCell>
                                                                    <TableCell>Date & Time</TableCell><TableCell>Gen Note</TableCell><TableCell align="center">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {payhistory.map((item, index) => (
                                                                    <TableRow key={index} hover>
                                                                        <TableCell>{item.paymode1}</TableCell><TableCell> {item.amount1}</TableCell><TableCell>{item.paytime1}</TableCell>
                                                                        <TableCell>{item.paymode2}</TableCell><TableCell> {item.amount2}</TableCell><TableCell>{item.paytime2}</TableCell>
                                                                        <TableCell>{item.createdat}</TableCell><TableCell>{item.note}</TableCell>
                                                                        <TableCell align="center">
                                                                            <IconButton color="success" onClick={() => handlePaymodeEdit(item.id, item.paymode1, item.paymode2)}><Edit /></IconButton>
                                                                            <IconButton color="error" onClick={() => deletPyament(item.id)}><DeleteIcon /></IconButton>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                {!payhistory.length && (
                                                                    <TableRow><TableCell colSpan={9} align="center">No payment history found</TableCell></TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CardContent>
                                            </Card>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3 mt-3">
                                    <Card sx={{ borderRadius: 1, mb: 2 }}>
                                        <CardContent>
                                            <Stack alignItems="center" spacing={1}>
                                                <Avatar sx={{ width: 70, height: 70, bgcolor: "primary.main" }}>{bookingData?.customers?.custname?.[0]}</Avatar>
                                                <Typography variant="h6" fontWeight={700} textTransform="capitalize">{bookingData.customers?.custname || "-"}</Typography>
                                                <Typography variant="body2" color="text.secondary">{bookingData.customers?.mobile || "-"}</Typography>
                                                <Button size="small" startIcon={<Edit />} onClick={() => { getCustData(); setCustModalOpen(true); }}>Edit Details</Button>
                                            </Stack>
                                            <Divider sx={{ my: 2 }} />
                                            <Stack spacing={1}>
                                                <ProfileItem label="Email" value={bookingData.customers?.email} />
                                                <ProfileItem label="Address" value={`${bookingData.customers?.city || ""}, ${bookingData.customers?.address || ""}, ${bookingData.customers?.state || ""}`} />
                                                <ProfileItem label="Gender" value={bookingData.customers?.gender} />
                                                <ProfileItem label="GST Name" value={bookingData.customers?.gstname} />
                                                <ProfileItem label="GST No" value={bookingData.customers?.gstno} />
                                                <ProfileItem label="Document Type" value={bookingData.customers?.documenttype} />
                                                <ProfileItem label="ID No" value={bookingData.customers?.idno} />
                                                <ProfileItem label="Visit Purpose" value={bookingData.visitpurpose} />
                                                <ProfileItem label="Booking Source" value={bookingData.bookingsource} />
                                                <ProfileItem label="Note" value={bookingData.note} />
                                            </Stack>
                                            {bookingData.additionalAdults && bookingData.additionalAdults.length > 0 && (
                                                <>
                                                    <Divider sx={{ my: 2 }} />
                                                    <Typography variant="subtitle2" color="primary" fontWeight={700} mb={1}>Additional Guests ({bookingData.additionalAdults.length})</Typography>
                                                    <Stack spacing={2}>
                                                        {bookingData.additionalAdults.map((adult, idx) => (
                                                            <Box key={idx} sx={{ p: 1.5, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
                                                                <Typography variant="caption" fontWeight={700} color="text.secondary" display="block">Guest #{idx + 1}</Typography>
                                                                <ProfileItem label="Name" value={adult.name} />
                                                                <ProfileItem label="Mobile" value={adult.mobile} />
                                                                <ProfileItem label="Email" value={adult.email} />
                                                                <ProfileItem label="Gender" value={adult.gender} />
                                                                <ProfileItem label="ID Type" value={adult.docType} />
                                                                <ProfileItem label="ID No" value={adult.idNo} />
                                                            </Box>
                                                        ))}
                                                    </Stack>
                                                </>
                                            )}

                                            {/* <Button fullWidth variant="contained" sx={{ mt: 3 }} onClick={() => { emptyRooms1(); setCheckoutOpen(true); }}>Check Out</Button> */}


                                            {/* {bookingData.status === "Booked" && bookingData.coming !== "No" && ( */}
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    sx={{ mt: 3 }}
                                                    onClick={() => { emptyRooms1(); setCheckoutOpen(true); }}
                                                >
                                                    Check Out
                                                </Button>
                                            {/* )} */}
                                        </CardContent>
                                    </Card>
                                    <ImageCard title="Visitor Photo" url={bookingData.visitorPhotoUrl} />
                                    <ImageCard title="ID Proof Front" url={bookingData.idFrontUrl} />
                                    <ImageCard title="ID Proof Back" url={bookingData.idBackUrl} />
                                    <ImageCard title="Couple Photo" url={bookingData.couplePhotoUrl} />
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Modals / Dialogs */}
                    <Dialog open={serviceModalOpen} onClose={() => setServiceModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Add Extra Service</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <TableContainer component={Paper} sx={{ mb: 2 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Service</TableCell><TableCell>Room</TableCell><TableCell>Amount</TableCell>
                                                <TableCell>Qty</TableCell><TableCell>Discount</TableCell><TableCell>Total</TableCell><TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Select size="small" fullWidth value={serviceid} onChange={handleServiceid}>
                                                        <MenuItem value="">Select</MenuItem>
                                                        {extraservices.map((item) => <MenuItem key={item.id} value={item.id}>{item.servicename}</MenuItem>)}
                                                    </Select>
                                                </TableCell>
                                                <TableCell>
                                                    <Select size="small" fullWidth value={roomid} onChange={(e) => setroomid(e.target.value)}>
                                                        <MenuItem value="">Select</MenuItem>
                                                        {(bookingData.rooms || []).map((item) => <MenuItem key={item.roomid} value={item.roomid}>{item.roomno}</MenuItem>)}
                                                    </Select>
                                                </TableCell>
                                                <TableCell><TextField size="small" value={servamount} onChange={hanldeServeAmount} /></TableCell>
                                                <TableCell><TextField size="small" value={quantity} onChange={handleQuantity} /></TableCell>
                                                <TableCell><TextField size="small" value={discount} onChange={handleDiscount} /></TableCell>
                                                <TableCell><TextField size="small" value={servicerate} InputProps={{ readOnly: true }} /></TableCell>
                                                <TableCell align="center"><IconButton color="primary" onClick={handleServiceArray}><AddIcon /></IconButton></TableCell>
                                            </TableRow>
                                            {services.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{item.servicename}</TableCell><TableCell>{item.roomno}</TableCell><TableCell>{item.servamount}</TableCell>
                                                    <TableCell>{item.quantity}</TableCell><TableCell>{item.discount}</TableCell><TableCell>{item.servicerate}</TableCell>
                                                    <TableCell align="center"><IconButton color="error" onClick={() => removeItem(item)}><DeleteIcon /></IconButton></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                <div className="row mt-3">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={paymode1} label="Pay Mode 1" onChange={(e) => setpaymode1(e.target.value)}>
                                                <MenuItem value="" />
                                                {paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" type="number" value={amount1} onChange={handleamount1} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment Note 1" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={paymode2} label="Pay Mode 2" onChange={(e) => setpaymode2(e.target.value)}>
                                                <MenuItem value="" />
                                                {paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" type="number" value={amount2} onChange={handleamount2} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment Note 2" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Total Amount" value={serviceamount} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-9 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setServiceModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storeService} disabled={isLoading}>{isLoading ? "Submitting..." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={custModalOpen} onClose={() => setCustModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Update Customer Details</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Customer Name" value={custname} onChange={(e) => setcustname(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Mobile" value={mobile} onChange={handlemobile} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Email" value={email} onChange={(e) => setemail(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Address" value={address} onChange={(e) => setaddress(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="City" value={city} onChange={(e) => setcity(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="State" value={state} onChange={(e) => setstate(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Gender</InputLabel>
                                            <Select value={gender} onChange={(e) => setgender(e.target.value)}>
                                                <MenuItem value="Male">Male</MenuItem><MenuItem value="Female">Female</MenuItem><MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Visit Purpose</InputLabel>
                                            <Select value={visitpurpose} onChange={(e) => setvisitpurpose(e.target.value)}>
                                                <MenuItem value="Darshan">Darshan</MenuItem><MenuItem value="Tourist">Tourist</MenuItem><MenuItem value="Business">Business</MenuItem><MenuItem value="Official">Official</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="GST Name" value={gstname} onChange={(e) => setgstname(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="GST No" value={gstno} onChange={(e) => setgstno(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Booking Source</InputLabel>
                                            <Select value={bookingsource} onChange={(e) => setbookingsource(e.target.value)}>
                                                <MenuItem value="Walking">Walking</MenuItem><MenuItem value="Website">Website</MenuItem><MenuItem value="OTA">OTA</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Document Type" value={documenttype} onChange={(e) => setdocumenttype(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="ID No" value={idno} onChange={(e) => setidno(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Adults" value={adults} onChange={(e) => setadults(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Childs" value={childs} onChange={(e) => setchilds(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setCustModalOpen(false)}>Cancel</Button>
                            <Button variant="contained" color="success" onClick={updateCust}>Submit</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={roomModalOpen} onClose={() => setRoomModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Add New Rooms</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row mb-3 align-items-center">
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Room Type</InputLabel>
                                            <Select value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>
                                                {roomtypes.map((item, index) => <MenuItem key={index} value={item.id}>{item.roomTypeName}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Room No</InputLabel>
                                            <Select value={roomid} onChange={(e) => setroomid(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>
                                                {rooms.filter(item => !bookedRoomIds.includes(item.id) && !bookingrooms.some(b => b.roomid === item.id)).length === 0 ? (
                                                    <MenuItem value="" disabled>No Rooms Available</MenuItem>
                                                ) : (
                                                    rooms.filter(item => !bookedRoomIds.includes(item.id) && !bookingrooms.some(b => b.roomid === item.id)).map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>{item.data.roomNo}</MenuItem>
                                                    ))
                                                )}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Plan Name</InputLabel>
                                            <Select value={planid} onChange={(e) => handleplanChange(e.target.value)}>
                                                <MenuItem value="OTA">OTA</MenuItem>
                                                {plans.map((item, index) => <MenuItem key={index} value={item.id}>{item.data.planName}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <TextField fullWidth size="small" type="number" value={amount} onChange={handleamountChange} label="Amount" />
                                    </div>
                                    <div className="col-12 col-md-1 mb-2">
                                        <TextField fullWidth size="small" value={discount} onChange={(e) => caltotal2(e.target.value)} label="Discount" />
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <TextField fullWidth size="small" type="number" value={roomrate} onChange={handleRoomRateChange} label="Rate" />
                                    </div>
                                    <div className="col-12 col-md-1 mb-2 text-center">
                                        <IconButton color="primary" onClick={handleRoomArray}><AddIcon /></IconButton>
                                    </div>
                                </div>
                                {bookingrooms.map((item, index) => (
                                    <div className="row mb-2 align-items-center" key={index}>
                                        <div className="col-12 col-md-2">{item.roomtypename}</div>
                                        <div className="col-12 col-md-2">{item.roomno}</div>
                                        <div className="col-12 col-md-2">{item.planname}</div>
                                        <div className="col-12 col-md-2">{item.amount}</div>
                                        <div className="col-12 col-md-1">{item.discount}%</div>
                                        <div className="col-12 col-md-2">{item.roomrate}</div>
                                        <div className="col-12 col-md-1 text-center"><IconButton color="error" onClick={() => removeItem1(item)}><DeleteIcon /></IconButton></div>
                                    </div>
                                ))}

                                <div className="row mt-3 border-top pt-3">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                                <MenuItem value="" />
                                                {paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" value={amount1} type="number" onChange={handleamount3} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                                <MenuItem value="" />
                                                {paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" value={amount2} type="number" onChange={handleamount4} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>

                                    <div className="col-12 col-md-3 mb-3">
                                        <TextField fullWidth size="small" label="Total Amount" value={rooamount} InputProps={{ readOnly: true }} />
                                        <Typography variant="caption">Room Amount for {bookingData.noofdays || 0} Days</Typography>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setRoomModalOpen(false)}>Cancel</Button>
                            <Button variant="contained" color="success" onClick={storeRoom} disabled={isLoading}>{isLoading ? "Wait.." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={payModalOpen} onClose={() => setPayModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Add Payment</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                                <MenuItem value="" />{paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" type="number" value={amount1} onChange={handleamount5} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                                <MenuItem value="" />{paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" type="number" value={amount2} onChange={handleamount6} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Total Amount" value={totalamount} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setPayModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storePayment} disabled={isLoading}>{isLoading ? "Submitting..." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={extendModalOpen} onClose={() => setExtendModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Extend Rooms</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel htmlFor="extend-room">Extend Room For</InputLabel>
                                            <OutlinedInput id="extend-room" value={extendRoom} onChange={handleExtendRoom} endAdornment={<InputAdornment position="end">Days</InputAdornment>} label="Extend Room For" />
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                                <MenuItem value="" />{paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" type="number" value={amount1} onChange={handleamount5} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                                <MenuItem value="" />{paymodes.map((p) => <MenuItem key={p.id} value={p.id}>{p.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" type="number" value={amount2} onChange={handleamount6} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment 2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Total Amount" value={totalamount} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setExtendModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={extendRoomStore} disabled={isLoading}>{isLoading ? "Wait.." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={reduceModalOpen} onClose={() => setReduceModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Reduce Rooms</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel htmlFor="reduce-room">Reduce Room For</InputLabel>
                                            <OutlinedInput id="reduce-room" value={extendRoom} onChange={handleReduceRoom} endAdornment={<InputAdornment position="end">Days</InputAdornment>} label="Reduce Room For" />
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Reduce Amount" value={totalamount} InputProps={{ readOnly: true }} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setReduceModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={reduceRoomStore} disabled={isLoading}>{isLoading ? "Wait.." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={exchangeModalOpen} onClose={() => setExchangeModalOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>EDIT / Exchange Rooms</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row mb-3">
                                    <div className="col-12"><Typography variant="subtitle1" fontWeight={700}>Old Room</Typography></div>
                                </div>
                                {exchangeItem && (
                                    <div className="row mb-3 border-bottom pb-3">
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Room Type" value={exchangeItem.roomtypename} InputProps={{ readOnly: true }} /></div>
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Room No" value={exchangeItem.roomno} InputProps={{ readOnly: true }} /></div>
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Plan Name" value={exchangeItem.planname} InputProps={{ readOnly: true }} /></div>
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Amount" value={exchangeItem.amount} InputProps={{ readOnly: true }} /></div>
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Discount" value={exchangeItem.discount} InputProps={{ readOnly: true }} /></div>
                                        <div className="col-12 col-md-2 mb-2"><TextField fullWidth size="small" label="Rate" value={exchangeItem.roomrate} InputProps={{ readOnly: true }} /></div>
                                    </div>
                                )}
                                <div className="row mt-3 align-items-center">
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>New Room Type</InputLabel>
                                            <Select value={rtypeid} onChange={(e) => handleroomtypeChange(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>
                                                {roomtypes.map((item, index) => <MenuItem key={index} value={item.id}>{item.roomTypeName}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>New Room No</InputLabel>
                                            <Select value={roomid} onChange={(e) => setroomid(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>
                                                {rooms.filter(item => !bookedRoomIds.includes(item.id)).length === 0 ? (
                                                    <MenuItem value="" disabled>No Rooms Available</MenuItem>
                                                ) : (
                                                    rooms.filter(item => !bookedRoomIds.includes(item.id)).map((item, index) => (
                                                        <MenuItem key={index} value={item.id}>{item.data.roomNo}</MenuItem>
                                                    ))
                                                )}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Plan Name</InputLabel>
                                            <Select value={planid} onChange={(e) => handleplanChange1(e.target.value)}>
                                                <MenuItem value="OTA">OTA</MenuItem>
                                                {plans.map((item, index) => <MenuItem key={index} value={item.id}>{item.data.planName}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <TextField fullWidth size="small" type="number" value={amount} onChange={handleamountChange} label="Amount" />
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <TextField fullWidth size="small" value={discount} onChange={(e) => caltotal2(e.target.value)} label="Discount" />
                                    </div>
                                    <div className="col-12 col-md-2 mb-2">
                                        <TextField fullWidth size="small" type="number" value={roomrate} onChange={handleRoomRateChange} label="Rate" />
                                    </div>
                                    <div className="col-12 col-md-3 mb-2 mt-2">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Is Old Room Dirty?</InputLabel>
                                            <Select value={durtyRoom} onChange={(e) => setdurtyRoom(e.target.value)}>
                                                <MenuItem value="Yes">Yes</MenuItem><MenuItem value="No">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-9 mb-2 mt-2">
                                        <TextField fullWidth size="small" label="Exchange Note" value={exchangeNote} onChange={(e) => setexchangeNote(e.target.value)} />
                                    </div>
                                    <div className="col-12 mt-3">
                                        {Number(rooamount) < 0 ? (
                                            <Typography variant="h6" color="success.main">Amount Payable To Customer:  {Math.abs(Number(rooamount))} /-</Typography>
                                        ) : (
                                            <Typography variant="h6" color="error.main">Amount Taken From Customer:  {rooamount} /-</Typography>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setExchangeModalOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storeRoomExchange} disabled={isLoading}>{isLoading ? "Wait.." : "Exchange Room"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={returnPaymentOpen} onClose={() => setReturnPaymentOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Return Payment</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" type="number" value={amount1} onChange={handleamountx1} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" type="number" value={amount2} onChange={handleamountx2} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Total Amount" value={totalamount} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                    <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setReturnPaymentOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={storePayment1} disabled={isLoading}>{isLoading ? "Wait.." : "Submit"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={checkoutOpen} onClose={() => setCheckoutOpen(false)} maxWidth="lg" fullWidth>
                        <DialogTitle>Checkout Room</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-3 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Any Damages</InputLabel>
                                            <Select value={anydamage} onChange={(e) => setanydamage(e.target.value)}>
                                                <MenuItem value="No">No</MenuItem><MenuItem value="Yes">Yes</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {anydamage === "Yes" && (
                                        <>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Damage Amount" type="number" value={damageamount} onChange={handleDamageAmount} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Damage Note" value={damagenote} onChange={(e) => setdamagenote(e.target.value)} /></div>
                                        </>
                                    )}
                                    {Number(totalamount) > 0 && (
                                        <>
                                            <div className="col-12 col-md-3 mb-3">
                                                <FormControl fullWidth size="small">
                                                    <InputLabel>Pay Mode 1</InputLabel>
                                                    <Select value={paymode1} onChange={(e) => setpaymode1(e.target.value)}>
                                                        <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 1" type="number" value={amount1} onChange={handleamount5} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment1 Note" value={paytime1} onChange={(e) => setpaytime1(e.target.value)} /></div>
                                            <div className="col-12 col-md-3 mb-3">
                                                <FormControl fullWidth size="small">
                                                    <InputLabel>Pay Mode 2</InputLabel>
                                                    <Select value={paymode2} onChange={(e) => setpaymode2(e.target.value)}>
                                                        <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Amount 2" type="number" value={amount2} onChange={handleamount6} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payment2 Note" value={paytime2} onChange={(e) => setpaytime2(e.target.value)} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Payable Amount" value={totalamount} InputProps={{ readOnly: true }} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Paid Amount" value={advance} InputProps={{ readOnly: true }} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Remaining" value={remaining} InputProps={{ readOnly: true }} /></div>
                                            <div className="col-12 col-md-3 mb-3"><TextField fullWidth size="small" label="Note" value={note} onChange={(e) => setnote(e.target.value)} /></div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setCheckoutOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={handleCheckout} disabled={isLoading}>{isLoading ? "Wait.." : "Checkout"}</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={paymodeEditOpen} onClose={() => setPaymodeEditOpen(false)} maxWidth="md" fullWidth>
                        <DialogTitle>Update Paymode</DialogTitle>
                        <DialogContent dividers>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 1</InputLabel>
                                            <Select value={uppaymode1} onChange={(e) => setuppaymode1(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Pay Mode 2</InputLabel>
                                            <Select value={uppaymode2} onChange={(e) => setuppaymode2(e.target.value)}>
                                                <MenuItem value="">Select</MenuItem>{paymodes.map((item, index) => <MenuItem key={index} value={item.id}>{item.paymode}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setPaymodeEditOpen(false)}>Close</Button>
                            <Button variant="contained" color="success" onClick={updatePaymode}>Update</Button>
                        </DialogActions>
                    </Dialog>
                </Card>
            )}
        </div>
    )
}

const overlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
};

const styles = StyleSheet.create({

    page: {
        padding: 30,
        fontFamily: 'Helvetica',
        fontSize: 10,
        backgroundColor: '#f9fafb'
    },
    invoiceContainer: {
        backgroundColor: '#ffffff',
        borderWidth: 1,
        borderColor: '#e5e7eb',
        borderRadius: 8,
        padding: 20,
    },
    topHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottomWidth: 2,
        borderBottomColor: '#1E3A8A',
        paddingBottom: 15,
        marginBottom: 20
    },
    companyInfo: { width: '65%' },
    propName: { fontSize: 22, fontWeight: 'bold', color: '#1E3A8A', marginBottom: 4, textTransform: 'uppercase' },
    propDetails: { fontSize: 9, color: '#4b5563', marginBottom: 2 },
    taxInvoiceWrapper: { width: '35%', alignItems: 'flex-end', justifyContent: 'center' },
    taxInvoiceBadge: {
        backgroundColor: '#1E3A8A',
        color: '#ffffff',
        padding: '6px 12px',
        borderRadius: 4,
        fontSize: 14,
        fontWeight: 'bold',
        letterSpacing: 1
    },
    infoSection: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 },
    infoBox: {
        width: '48%',
        borderWidth: 1,
        borderColor: '#e5e7eb',
        borderRadius: 6,
        padding: 10,
        backgroundColor: '#f8fafc'
    },
    boxTitle: { fontSize: 11, fontWeight: 'bold', color: '#1E3A8A', borderBottomWidth: 1, borderBottomColor: '#e5e7eb', paddingBottom: 4, marginBottom: 6, textTransform: 'uppercase' },
    infoRow: { flexDirection: 'row', marginBottom: 4 },
    infoLabel: { width: '35%', fontWeight: 'bold', color: '#4b5563', fontSize: 9 },
    infoValue: { width: '65%', color: '#111827', fontSize: 9 },

    table: {
        width: '100%',
        borderWidth: 1,
        borderColor: '#e5e7eb',
        borderRadius: 6,
        marginBottom: 20,
        overflow: 'hidden'
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#1E3A8A',
        padding: '8px 5px',
        color: '#ffffff',
        fontWeight: 'bold',
        fontSize: 9
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
        padding: '8px 5px',
        alignItems: 'center',
        fontSize: 9,
        color: '#374151'
    },
    col1: { width: '15%' }, col2: { width: '10%' }, col3: { width: '15%' },
    col4: { width: '10%', textAlign: 'right' }, col5: { width: '10%', textAlign: 'right' },
    col6: { width: '15%', textAlign: 'right' }, col7: { width: '10%', textAlign: 'right' },
    col8: { width: '15%', textAlign: 'right', fontWeight: 'bold' },

    bottomSection: { flexDirection: 'row', justifyContent: 'space-between' },
    bankBox: { width: '48%', borderRadius: 6, padding: 10 },
    bankText: { fontSize: 9, color: '#4b5563', marginBottom: 4 },
    bankTextBold: { fontWeight: 'bold', color: '#111827' },

    totalsBox: { width: '48%', borderWidth: 1, borderColor: '#e5e7eb', borderRadius: 6, padding: 10 },
    totalRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 6 },
    totalLabel: { fontWeight: 'bold', color: '#4b5563', fontSize: 10 },
    totalValue: { fontWeight: 'bold', color: '#111827', fontSize: 10 },
    grandTotalRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 6,
        paddingTop: 8,
        borderTopWidth: 2,
        borderTopColor: '#1E3A8A'
    },
    grandTotalLabel: { fontWeight: 'bold', color: '#1E3A8A', fontSize: 12, textTransform: 'uppercase' },
    grandTotalValue: { fontWeight: 'bold', color: '#1E3A8A', fontSize: 12 },

    footer: { marginTop: 25, borderTopWidth: 1, borderTopColor: '#e5e7eb', paddingTop: 15, textAlign: 'center' },
    footerAmountInWords: { fontSize: 10, fontStyle: 'italic', color: '#4b5563', textTransform: 'capitalize', marginBottom: 6 },
    footerThankYou: { fontSize: 11, fontWeight: 'bold', color: '#1E3A8A', letterSpacing: 0.5 }
});

export default Reservationdetails;